import { useState, useCallback } from 'react';
import { GameNotification } from '@/components/ui/game-notifications';

export const useGameNotifications = () => {
  const [notifications, setNotifications] = useState<GameNotification[]>([]);
  
  // Function to show a notification
  const showNotification = useCallback((
    title: string, 
    message: string, 
    type: 'info' | 'warning' | 'error' = 'info', 
    timeout = 5000
  ) => {
    const id = Date.now().toString();
    const notification: GameNotification = { id, title, message, type, timeout };
    
    setNotifications(prev => [...prev, notification]);
    
    // Auto-remove notification after timeout
    if (timeout) {
      setTimeout(() => {
        removeNotification(id);
      }, timeout);
    }

    return id;
  }, []);

  // Function to remove a notification
  const removeNotification = useCallback((id: string) => {
    setNotifications(prev => prev.filter(notification => notification.id !== id));
  }, []);

  return {
    notifications,
    showNotification,
    removeNotification
  };
};

export default useGameNotifications;